import firebase from 'firebase/app'
import 'firebase/database'
import config from '../services/firebaseConfig'

if (!firebase.apps.length) {
  firebase.initializeApp(config)
}

const userDBReference = firebase.database().ref('users')

const userRepository = {
  /**
   * Saves a user to the database
   * @param userObj User object
   */
  saveUser (user) {
    return new Promise((resolve, reject) => {
      userDBReference.child(user.uid).set({
        userName: user.userName,
        emailId: 'defaultPollscapeUser@gmail.com',
        photoUrl: user.photoUrl
      }).then(() => {
        resolve(true)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default userRepository



// WEBPACK FOOTER //
// ./src/repositories/UserRepository.js